/* Lapwell landing — interactions.
   Lapwell landing interactions; every lookup is guarded so the page still
   works while image slots are empty and the gallery has nothing to swap. */
document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('.lapwell-lp');
  if (!root) return;
  var $ = function (id) { return document.getElementById(id); };

  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveals ----------
     .rv starts at opacity 0, so if this never runs the page reads as blank.
     IntersectionObserver does the work; a passive scroll sweep is the net. */
  function revealSweep() {
    root.querySelectorAll('.rv:not(.in)').forEach(function (el) {
      if (el.getBoundingClientRect().top < innerHeight * 0.95) el.classList.add('in');
    });
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: .12 });
    root.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });
    addEventListener('scroll', revealSweep, { passive: true });
    addEventListener('resize', revealSweep);
    revealSweep();
  } else {
    root.querySelectorAll('.rv').forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------- burger ---------- */
  var burger = $('burger');
  if (burger) burger.addEventListener('click', function () { document.body.classList.toggle('menu-open'); });
  root.querySelectorAll('.mmenu a').forEach(function (a) {
    a.addEventListener('click', function () { document.body.classList.remove('menu-open'); });
  });

  /* ---------- gallery ---------- */
  var mainImg = $('mainImg');
  var thumbs = [].slice.call(root.querySelectorAll('#pthumbs .pt[data-src]'));
  var slides = thumbs.map(function (b) { return b.dataset.src; });
  var slideAlts = thumbs.map(function (b) {
    var im = b.querySelector('img');
    return (im && im.alt) || 'The Lapwell lick mat';
  });
  var gi = 0;
  function gShow(i) {
    if (!mainImg || !slides.length) return;
    gi = (i + slides.length) % slides.length;
    mainImg.style.opacity = 0;
    setTimeout(function () {
      mainImg.src = slides[gi];
      if (slideAlts[gi]) mainImg.alt = slideAlts[gi];
      mainImg.style.opacity = 1;
    }, 150);
    thumbs.forEach(function (b, j) { b.classList.toggle('on', j === gi); });
    if (thumbs[gi]) thumbs[gi].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
  }
  thumbs.forEach(function (b, j) {
    b.addEventListener('click', function (e) { e.stopPropagation(); gShow(j); });
  });
  var gprev = $('gprev'), gnext = $('gnext');
  if (slides.length > 1) {
    if (gprev) gprev.addEventListener('click', function (e) { e.stopPropagation(); gShow(gi - 1); });
    if (gnext) gnext.addEventListener('click', function (e) { e.stopPropagation(); gShow(gi + 1); });
    addEventListener('keydown', function (e) {
      var lbEl = $('lb');
      if (lbEl && lbEl.classList.contains('on')) return;
      if (e.key === 'ArrowLeft') gShow(gi - 1);
      if (e.key === 'ArrowRight') gShow(gi + 1);
    });
  } else {
    if (gprev) gprev.style.display = 'none';
    if (gnext) gnext.style.display = 'none';
  }

  /* ---------- buy options ---------- */
  var atc = $('atc'), barPrice = $('barPrice');
  root.querySelectorAll('#buyopts .bopt').forEach(function (o) {
    var pick = function () {
      root.querySelectorAll('#buyopts .bopt').forEach(function (x) { x.classList.remove('on'); });
      o.classList.add('on');
      if (atc) atc.innerHTML = o.dataset.cta + '<span class="sheen"></span>';
      if (barPrice) barPrice.innerHTML = o.dataset.price + ' <small>Lapwell · ' + (o.dataset.label || '1 mat') + '</small>';
      if (o.dataset.slide !== undefined) gShow(parseInt(o.dataset.slide, 10));
    };
    o.addEventListener('click', pick);
    o.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); }
    });
  });

  /* ---------- lightbox ---------- */
  var lb = $('lb'), lbImg = $('lbImg'), lbVid = $('lbVid'), lbCap = $('lbCap'), lbX = $('lbX');
  function lbOpen(src, isVid, cap) {
    if (!lb) return;
    lbImg.style.display = isVid ? 'none' : 'block';
    lbVid.style.display = isVid ? 'block' : 'none';
    if (isVid) { lbVid.src = src; lbVid.muted = false; lbVid.play().catch(function () {}); }
    else { lbImg.src = src; lbImg.alt = cap || 'Lapwell lick mat, enlarged'; lbVid.pause(); }
    lbCap.textContent = cap || '';
    lb.classList.add('on');
  }
  function lbClose() {
    if (!lb) return;
    lb.classList.remove('on'); lbVid.pause(); lbVid.removeAttribute('src');
  }
  root.querySelectorAll('[data-view]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (e.target.closest('a,button')) return;
      var vid = el.querySelector('video'), img = el.querySelector('img');
      if (vid) lbOpen(vid.currentSrc || vid.src, true, '');
      else if (img) lbOpen(img.currentSrc || img.src, false, img.alt || '');
    });
  });
  if (lbX) lbX.addEventListener('click', lbClose);
  if (lb) lb.addEventListener('click', function (e) { if (e.target === lb) lbClose(); });
  addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb && lb.classList.contains('on')) lbClose(); });

  /* ---------- videos: play only when visible, fall back to poster ---------- */
  root.querySelectorAll('video[autoplay]').forEach(function (v) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); } });
    }, { threshold: .15 }).observe(v);
    v.addEventListener('error', function () {
      if (!v.poster) return;
      var img = document.createElement('img'); img.src = v.poster; v.replaceWith(img);
    }, true);
  });

  /* ---------- thumbnail strip arrows ---------- */
  var pth = $('pthumbs'), tP = $('tPrev'), tN = $('tNext');
  if (tP && pth) tP.addEventListener('click', function (e) { e.stopPropagation(); pth.scrollBy({ left: -190, behavior: 'smooth' }); });
  if (tN && pth) tN.addEventListener('click', function (e) { e.stopPropagation(); pth.scrollBy({ left: 190, behavior: 'smooth' }); });

  /* ---------- UGC strip: drag + progress bar ---------- */
  var vs = $('vslider'), vsBar = $('vsBar');
  if (vs && vsBar) {
    var syncBar = function () {
      var max = vs.scrollWidth - vs.clientWidth;
      var frac = vs.clientWidth / vs.scrollWidth;
      vsBar.style.width = Math.max(12, frac * 100) + '%';
      var travel = vs.clientWidth * (1 - frac);
      vsBar.style.transform = 'translateX(' + (max > 0 ? (vs.scrollLeft / max) * travel : 0) + 'px)';
    };
    vs.addEventListener('scroll', syncBar, { passive: true });
    addEventListener('resize', syncBar);
    setTimeout(syncBar, 200); syncBar();
    var vdn = false, vsx = 0, vsl = 0;
    vs.addEventListener('pointerdown', function (e) { vdn = true; vsx = e.clientX; vsl = vs.scrollLeft; vs.classList.add('drag'); vs.setPointerCapture(e.pointerId); });
    vs.addEventListener('pointermove', function (e) { if (vdn) { vs.scrollLeft = vsl - (e.clientX - vsx); syncBar(); } });
    ['pointerup', 'pointercancel'].forEach(function (ev) { vs.addEventListener(ev, function () { vdn = false; vs.classList.remove('drag'); }); });
  }

  /* ---------- buy-box mini review carousel ---------- */
  var mrT = $('mrTrack'), mrD = $('mrDots');
  if (mrT && mrD) {
    var mrGo = function (d) { mrT.scrollTo({ left: (Math.round(mrT.scrollLeft / mrT.clientWidth) + d) * mrT.clientWidth, behavior: 'smooth' }); };
    var mrP = $('mrPrev'), mrN = $('mrNext');
    if (mrP) mrP.addEventListener('click', function () { mrGo(-1); });
    if (mrN) mrN.addEventListener('click', function () { mrGo(1); });
    var dots = [].slice.call(mrD.children);
    var setDot = function (i) { dots.forEach(function (d, j) { d.classList.toggle('on', j === i); }); };
    mrT.addEventListener('scroll', function () {
      var i = Math.round(mrT.scrollLeft / mrT.clientWidth);
      setDot(Math.max(0, Math.min(dots.length - 1, i)));
    }, { passive: true });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { mrT.scrollTo({ left: i * mrT.clientWidth, behavior: 'smooth' }); }); });
    var mdn = false, msx = 0, msl = 0;
    mrT.addEventListener('pointerdown', function (e) { mdn = true; msx = e.clientX; msl = mrT.scrollLeft; mrT.setPointerCapture(e.pointerId); });
    mrT.addEventListener('pointermove', function (e) { if (mdn) mrT.scrollLeft = msl - (e.clientX - msx); });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      mrT.addEventListener(ev, function () {
        mdn = false;
        mrT.scrollTo({ left: Math.round(mrT.scrollLeft / mrT.clientWidth) * mrT.clientWidth, behavior: 'smooth' });
      });
    });
  }

  /* ---------- evidence rings: fill + count up ---------- */
  root.querySelectorAll('.ring').forEach(function (ring) {
    new IntersectionObserver(function (es, obs) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        obs.unobserve(ring);
        ring.classList.add('go');
        var span = ring.querySelector('.rnum');
        if (!span) return;
        var target = parseInt(span.dataset.t, 10), t0 = Date.now(), dur = 1800;
        var tick = setInterval(function () {
          var k = Math.min(1, (Date.now() - t0) / dur);
          var ease = 1 - Math.pow(1 - k, 3);
          span.textContent = Math.round(target * ease) + '%';
          if (k >= 1) clearInterval(tick);
        }, 30);
      });
    }, { threshold: .5 }).observe(ring);
  });

  /* ---------- benefit rows: scroll-following drop line ---------- */
  var benwrap = $('benwrap'), blit = $('blit'), bdrop = $('bdrop');
  if (benwrap && blit && bdrop && matchMedia('(min-width:900px)').matches && !reduced) {
    var bTop = 0, bH = 1, nodes = [];
    var measure = function () {
      var r = benwrap.getBoundingClientRect();
      bTop = r.top + scrollY + 30; bH = Math.max(1, benwrap.offsetHeight - 60);
      benwrap.querySelectorAll('.bnode').forEach(function (nd) { nd.remove(); });
      nodes.length = 0;
      benwrap.querySelectorAll('.ben').forEach(function (b) {
        var br = b.getBoundingClientRect();
        var ratio = Math.min(1, Math.max(0, ((br.top + scrollY + br.height / 2) - bTop) / bH));
        var el = document.createElement('div'); el.className = 'bnode';
        el.style.top = (30 + ratio * bH) + 'px'; el.dataset.ratio = ratio;
        benwrap.appendChild(el); nodes.push(el);
      });
    };
    var lastP = -1;
    var update = function () {
      var p = Math.min(1, Math.max(0, (scrollY + innerHeight * .5 - bTop) / bH));
      if (Math.abs(p - lastP) < 0.0005) return;
      lastP = p;
      blit.style.height = (p * 100) + '%';
      bdrop.style.top = (30 + p * bH) + 'px';
      bdrop.style.opacity = p > 0.003 && p < 0.997 ? 1 : 0;
      nodes.forEach(function (nd) { nd.classList.toggle('on', p >= parseFloat(nd.dataset.ratio)); });
    };
    measure(); update();
    (function bloop() { update(); requestAnimationFrame(bloop); })();
    addEventListener('resize', function () { measure(); lastP = -1; update(); });
    addEventListener('load', function () { measure(); lastP = -1; update(); });
    setTimeout(function () { measure(); lastP = -1; update(); }, 1500);
  }

  /* ---------- sticky buy bar hides over the hero ---------- */
  var heroEl = root.querySelector('.hero'), bar = $('buybar');
  if (heroEl && bar) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { bar.style.display = e.isIntersecting ? 'none' : ''; });
    }, { threshold: .05 }).observe(heroEl);
  }

  /* ---------- paw cursor ---------- */
  var paw = root.querySelector('.cursor-paw'), ringC = root.querySelector('.cursor-ring');
  if (paw && ringC && matchMedia('(hover:hover)').matches && !reduced) {
    var rx = -100, ry = -100, tx = -100, ty = -100, live = false;
    addEventListener('mousemove', function (e) {
      if (!live) { live = true; rx = e.clientX; ry = e.clientY; document.body.classList.add('cursor-on'); }
      tx = e.clientX; ty = e.clientY;
      paw.style.left = tx + 'px'; paw.style.top = ty + 'px';
    });
    (function loop() { rx += (tx - rx) * .16; ry += (ty - ry) * .16; ringC.style.left = rx + 'px'; ringC.style.top = ry + 'px'; requestAnimationFrame(loop); })();
    addEventListener('mousedown', function () { document.body.classList.add('cursor-down'); });
    addEventListener('mouseup', function () { document.body.classList.remove('cursor-down'); });
    root.querySelectorAll('[data-hover],a,button,summary,[data-view],.bopt').forEach(function (el) {
      el.addEventListener('mouseenter', function () { document.body.classList.add('cursor-hover'); });
      el.addEventListener('mouseleave', function () { document.body.classList.remove('cursor-hover'); });
    });
    addEventListener('click', function (e) {
      var r = document.createElement('div'); r.className = 'ripple';
      r.style.left = e.clientX + 'px'; r.style.top = e.clientY + 'px';
      document.body.appendChild(r); setTimeout(function () { r.remove(); }, 600);
    });
  }

  /* ---------- secondary CTAs preselect a tier ---------- */
  root.querySelectorAll('[data-pick]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var opt = root.querySelector('#buyopts .bopt[data-label="' + btn.dataset.pick + '"]');
      if (opt) setTimeout(function () { opt.click(); }, 40);
    });
  });

  /* ---------- Shopify cart + slide-in drawer ---------- */
  (function () {
    var colour = 'blue';

    /* colour swatch: sets the variant AND jumps the gallery to that colour */
    function showColour(c) {
      var idx = thumbs.findIndex(function (t) { return t.dataset.colour === c; });
      if (idx > -1) gShow(idx);
    }
    root.querySelectorAll('.swatches .sw').forEach(function (b) {
      b.addEventListener('click', function () {
        colour = b.dataset.colour;
        root.querySelectorAll('.swatches .sw').forEach(function (x) {
          var on = x === b;
          x.classList.toggle('on', on);
          x.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        showColour(colour);
      });
    });

    function variant() {
      var sel = root.querySelector('#buyopts .bopt.on');
      if (!sel) return '';
      var id = sel.dataset['variant' + colour.charAt(0).toUpperCase() + colour.slice(1)] || sel.dataset.variant || '';
      return id.trim();
    }

    /* ---- drawer ---- */
    var drawer = $('cartDrawer'), scrim = $('cartScrim'), body = $('cdBody'),
        foot = $('cdFoot'), subEl = $('cdSub'), cdCount = $('cdCount'),
        goAmt = $('cdGoAmt'), ship = $('cdShip'), lastFocus = null;

    function money(cents, cur) {
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur || 'USD' }).format(cents / 100); }
      catch (e) { return '$' + (cents / 100).toFixed(2); }
    }
    function openDrawer() {
      lastFocus = document.activeElement;
      scrim.hidden = false; drawer.hidden = false;
      void drawer.offsetHeight;              // force reflow so the slide-in animates
      document.body.classList.add('cart-open');
      drawer.setAttribute('aria-hidden', 'false');
      var x = $('cdClose'); if (x) x.focus();
    }
    function closeDrawer() {
      document.body.classList.remove('cart-open');
      drawer.setAttribute('aria-hidden', 'true');
      setTimeout(function () { scrim.hidden = true; drawer.hidden = true; }, 280);
      if (lastFocus) lastFocus.focus();
    }
    function colourOf(t) { return /pink/i.test(t || '') ? 'pink' : 'blue'; }
    function imgFor(it) {
      // the colour the buyer picked wins — the product's featured image is one colour for all variants
      var byColour = drawer.dataset['img' + (colourOf(it.variant_title) === 'pink' ? 'Pink' : 'Blue')];
      if (byColour) return byColour;
      return it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
    }
    function render(cart) {
      var count = cart.item_count || 0;
      if (cdCount) cdCount.textContent = count ? count + (count === 1 ? ' item' : ' items') : '';
      if (!cart.items || !cart.items.length) {
        body.innerHTML = '<div class="cd-empty"><p>Your cart is empty.</p>' +
          '<button class="cd-cont" data-close>Back to the mat</button></div>';
        foot.hidden = true;
        if (ship) ship.hidden = true;
        return;
      }
      if (ship) ship.hidden = false;
      body.innerHTML = cart.items.map(function (it) {
        var src = imgFor(it);
        var c = colourOf(it.variant_title);
        return '<div class="cd-item" data-key="' + it.key + '">' +
          '<div class="cd-thumb ' + c + '">' + (src ? '<img src="' + src + '" alt="" width="76" height="76" loading="lazy">' : '') + '</div>' +
          '<div class="cd-meta">' +
            '<span class="cd-brand">Lapwell lick mat</span>' +
            '<b>' + (it.variant_title || it.product_title) + '</b>' +
            '<div class="cd-row">' +
              // each variant is already a bundle (one/two/three mats), so a stepper would
              // sell 2 x three-mat packs and read as "2 items". Show the pack instead.
              '<span class="cd-packs">' + it.quantity + ' \u00d7 ' + (it.variant_title || 'pack') + '</span>' +
              '<button class="cd-rm" aria-label="Remove">Remove</button>' +
            '</div>' +
          '</div>' +
          '<span class="cd-price">' + money(it.final_line_price, cart.currency) + '</span></div>';
      }).join('');
      // pin a useful card to the bottom of the scroll area so a short cart isn't a hole
      body.insertAdjacentHTML('beforeend',
        '<div class="cd-aside">' +
          '<div class="cd-aside-ic" aria-hidden="true">' +
            '<svg viewBox="0 0 24 24" fill="none" width="18" height="18">' +
            '<path d="M5 4h11l3 3v13H5z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>' +
            '<path d="M8 11h8M8 15h5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg></div>' +
          '<div><b>Not sure what to put on it?</b>' +
          '<p>Six recipes, four ingredients or fewer, out of a normal fridge.</p>' +
          '<button class="cd-link" data-go="#recipes">See the recipes</button></div>' +
        '</div>');
      subEl.textContent = money(cart.total_price, cart.currency);
      if (goAmt) goAmt.textContent = money(cart.total_price, cart.currency);
      foot.hidden = false;
    }
    function refresh() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); }).then(render);
    }
    function change(key, qty) {
      body.classList.add('cd-busy');
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); })
        .then(render).finally(function () { body.classList.remove('cd-busy'); });
    }
    if (body) body.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) return closeDrawer();
      var jump = e.target.closest('[data-go]');
      if (jump) {
        closeDrawer();
        var target = root.querySelector(jump.dataset.go);
        if (target) setTimeout(function () { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 300);
        return;
      }
      var row = e.target.closest('.cd-item'); if (!row) return;
      var key = row.dataset.key;
      var qEl = row.querySelector('.cd-step span');
      var q = qEl ? (parseInt(qEl.textContent, 10) || 1) : 1;
      if (e.target.closest('.cd-rm')) return change(key, 0);
      if (e.target.closest('.cd-less')) return change(key, Math.max(0, q - 1));
      if (e.target.closest('.cd-more')) return change(key, q + 1);
    });
    if ($('cdClose')) $('cdClose').addEventListener('click', closeDrawer);
    if ($('cdCont')) $('cdCont').addEventListener('click', closeDrawer);
    if (scrim) scrim.addEventListener('click', closeDrawer);
    addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('cart-open')) closeDrawer();
    });

    /* ---- add to cart: open the drawer, never redirect ---- */
    function go(e) {
      var id = variant();
      if (!id) return;                       // not wired yet — let the anchor scroll
      e.preventDefault();
      var btn = e.currentTarget;
      var was = btn.innerHTML;
      btn.classList.add('is-busy');
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return refresh();
      }).then(function () {
        openDrawer();
      }).catch(function () {
        // never navigate away — say so in the drawer and let the buyer choose
        body.innerHTML = '<p class="cd-empty">We could not reach the cart just then. ' +
          'Please try again, or <a href="/cart">open the cart page</a>.</p>';
        foot.hidden = true;
        openDrawer();
      }).finally(function () {
        btn.classList.remove('is-busy'); btn.innerHTML = was;
      });
    }
    if (atc) atc.addEventListener('click', go);
    root.querySelectorAll('.buybar .btn').forEach(function (b) { b.addEventListener('click', go); });
  })();
});

/* ---- Self-serve stopwatch. No number is printed on this page; the buyer takes their own. ---- */
(function(){
  var out=document.getElementById('swT'),go=document.getElementById('swGo'),rs=document.getElementById('swRs');
  if(!out||!go||!rs) return;
  var t0=0,acc=0,id=null;
  function fmt(ms){var m=Math.floor(ms/60000),s=Math.floor(ms%60000/1000),d=Math.floor(ms%1000/100);
    return (m<10?'0':'')+m+':'+(s<10?'0':'')+s+'.'+d;}
  function tick(){out.textContent=fmt(acc+(Date.now()-t0));}
  go.addEventListener('click',function(){
    if(id){clearInterval(id);id=null;acc+=Date.now()-t0;go.textContent='Start';go.classList.add('swb-go');}
    else{t0=Date.now();id=setInterval(tick,100);go.textContent='Stop';go.classList.remove('swb-go');}
  });
  rs.addEventListener('click',function(){
    if(id){clearInterval(id);id=null;} acc=0;out.textContent='00:00.0';
    go.textContent='Start';go.classList.add('swb-go');
  });
})();
